export default __webpack_public_path__ + "static/ministerio-f14c1cb1754ed7673a365e50fcdbcaad.svg";